<template>
  <aside :class="[
    'transition-all duration-200 h-screen',
    'border-r border-gray-200 dark:border-gray-700',
    'bg-white dark:bg-gray-800',
    open ? 'w-56' : 'w-16',
    mobile
      ? [
          'fixed z-40 left-0 top-0',
          open ? 'translate-x-0' : '-translate-x-full',
          'transition-transform duration-300'
        ]
      : 'relative',
    'flex flex-col',
    'text-gray-700 dark:text-white',
    'pr-1'
  ]">
    <div class="flex items-center h-12 px-3 border-b border-gray-100 dark:border-gray-700">
      <span class="font-bold text-violet-600 text-lg" v-if="open">Myco</span>
      <span v-else class="font-bold text-violet-600 text-base">Myco</span>
      <button @click="$emit('toggleSidebar')" class="ml-auto p-1 rounded hover:bg-violet-100 dark:hover:bg-gray-700">
        <svg class="w-3 h-3 text-gray-500 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </button>
    </div>
    <nav class="flex-1 overflow-y-auto py-2" v-if="userStore.negocioSeleccionado || userStore.isSuper">
      <!-- Admin Section for Super Users -->
      <div v-if="userStore.isSuper" class="mb-2">
        <div class="px-3 text-[10px] text-gray-400 dark:text-gray-300 uppercase tracking-wider mb-0.5" v-if="open">Administración</div>
        <ul>
          <li>
            <router-link to="/admin/users" class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/admin/users')">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"/>
              </svg>
              <span v-if="open">Gestionar Usuarios</span>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/negocios" class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/admin/negocios')">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H5m0 0h2M7 7h10M7 11h10M7 15h10"/>
              </svg>
              <span v-if="open">Gestionar Negocios</span>
            </router-link>
          </li>
          <!-- <li>
            <router-link to="/admin/usuario-negocio" class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/admin/usuario-negocio')">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              <span v-if="open">Asignar Usuarios</span>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/usuario-negocio-v2" class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/admin/usuario-negocio-v2')">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>
              </svg>
              <span v-if="open">Asignación Masiva</span>
            </router-link>
          </li> -->
          <li>
            <router-link to="/admin/usuario-negocio-v3" class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/admin/usuario-negocio-v3')">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"/>
              </svg>
              <span v-if="open">Negocios X Usuario</span>
            </router-link>
          </li>
          <li>
            <router-link to="/seleccionar-negocio" class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/seleccionar-negocio')">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
              </svg>
              <span v-if="open">Selector de Negocio</span>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/roles-secciones" class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/admin/roles-secciones')">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
              </svg>
              <span v-if="open">Roles y Secciones KDS</span>
            </router-link>
          </li>
        </ul>
        <div class="my-4 border-t border-gray-100 dark:border-gray-700"></div>
      </div>
      
      <!-- Regular menu sections - only show if business is selected AND not in admin routes -->
      <div v-if="userStore.negocioSeleccionado ">
        <!-- POS2 Section -->
        <ul>
          <li>
            <button @click="togglePOS2" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isPOS2Active() + ' pr-4'">
              <div class="flex items-center gap-3">
                <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                </svg>
                <span v-if="open">POS2</span>
              </div>
              <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="pos2Open ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <ul v-if="pos2Open && open" class="ml-4 mt-1 space-y-1">
              <li>
                <router-link to="/pos2/pedidos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/pedidos')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Pedidos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/ordenes-produccion" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/ordenes-produccion')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Órdenes de Producción</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/notas" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/notas')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Notas de Venta</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/facturas" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/facturas')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Facturas Electrónicas</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/esquemas-facturacion" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/esquemas-facturacion')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Esquemas Facturación</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/disenadores" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/disenadores')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Diseñadores</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/tipos-componente" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/tipos-componente')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Tipos de Componente</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/tipos-material" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/tipos-material')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Tipos de Material</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/tipos-papel" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/tipos-papel')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Tipos de Papel</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/tipos-cliente" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/tipos-cliente')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Tipos de Cliente</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/plantas" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/plantas')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Plantas</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/empleados" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/empleados')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Empleados</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/clientes" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/clientes')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Clientes</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/departamentos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/departamentos')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Departamentos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/unidades-medida" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/unidades-medida')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Unidades de Medida</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/productos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/productos')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Productos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/categorias" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/categorias')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Categorías</span>
                </router-link>
              </li>
              <li>
                <router-link to="/pos2/proveedores" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pos2/proveedores')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Proveedores</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
        <!-- Productos Section -->
        <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
        <ul>
          <li>
            <button @click="toggleProductos" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isProductosActive() + ' pr-4'">
              <div class="flex items-center gap-3">
                <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                </svg>
                <span v-if="open">Productos</span>
              </div>
              <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="productosOpen ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <ul v-if="productosOpen && open" class="ml-4 mt-1 space-y-1">
              <li>
                <router-link to="/prototipos-new"  class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/prototipos')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Prototipos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/cotizaciones" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/cotizaciones')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Cotizaciones</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Cotizaciones Section -->
        <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
        <ul>
          <li>
            <button @click="toggleCotizaciones" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isCotizacionesActive() + ' pr-4'">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <span v-if="open">Cotizaciones</span>
              </div>
              <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="cotizacionesOpen ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <ul v-if="cotizacionesOpen && open" class="ml-4 mt-1 space-y-1">
              <li>
                <router-link to="/cotizaciones/dashboard" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/cotizaciones/dashboard')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Dashboard</span>
                </router-link>
              </li>
              <li>
                <router-link to="/cotizaciones" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/cotizaciones') && !route.path.includes('dashboard')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Lista</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Pedidos Section -->
        <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
        <ul>
          <li>
            <button @click="togglePedidos" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isPedidosActive() + ' pr-4'">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
                </svg>
                <span v-if="open">Pedidos</span>
              </div>
              <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="pedidosOpen ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <ul v-if="pedidosOpen && open" class="ml-4 mt-1 space-y-1">
              <li>
                <router-link to="/pedidos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/pedidos') && !route.path.match(/\/pedidos\/\d+/)">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Lista</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Control Financiero Section -->
        <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
        <ul>
          <li>
            <button @click="toggleFinanzas" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isFinanzasActive() + ' pr-4'">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span v-if="open">Control Financiero</span>
              </div>
              <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="finanzasOpen ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <ul v-if="finanzasOpen && open" class="ml-4 mt-1 space-y-1">
              <li>
                <router-link to="/finanzas/tablero" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/tablero')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Tablero</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/cuentas-bancarias" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/cuentas-bancarias')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Cuentas Bancarias</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/categorias" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/categorias')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Categorías</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/movimientos/ingresos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/movimientos/ingresos')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Ingresos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/movimientos/gastos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/movimientos/gastos')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Gastos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/movimientos/transferencias" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/movimientos/transferencias')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Transferencias</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/cuentas-por-cobrar" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/cuentas-por-cobrar')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Cuentas por Cobrar</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/cuentas-por-pagar" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/cuentas-por-pagar')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Cuentas por Pagar</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/flujo-caja" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/flujo-caja')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Flujo de Caja</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/presupuestos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/presupuestos')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Presupuestos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/reportes" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/reportes')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Reportes</span>
                </router-link>
              </li>
              <li>
                <router-link to="/finanzas/configuracion" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/finanzas/configuracion')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Configuración</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
        <!-- Inventario Section -->
        <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
        <ul>
          <li>
            <button @click="toggleInventario" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isInventarioActive() + ' pr-4'">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                </svg>
                <span v-if="open">Inventario</span>
              </div>
              <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="inventarioOpen ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <ul v-if="inventarioOpen && open" class="ml-4 mt-1 space-y-1">
              <li>
                <router-link to="/inventario/productos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/inventario/productos')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Productos</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventario/materias-primas" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/inventario/materias-primas')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Materias Primas</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventario/entradas" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/inventario/entradas')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Entradas</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventario/salidas" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/inventario/salidas')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Salidas</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventario/ajustes" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/inventario/ajustes')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Ajustes</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventario/proveedores" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/inventario/proveedores')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Proveedores</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventario/reportes" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/inventario/reportes')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Reportes</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventario/configuracion" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/inventario/configuracion')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Configuración</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Ventas Section -->
        <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
        <ul>
          <li>
            <button @click="toggleVentas" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isVentasActive() + ' pr-4'">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
                <span v-if="open">Ventas</span>
              </div>
              <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="ventasOpen ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <ul v-if="ventasOpen && open" class="ml-4 mt-1 space-y-1">
              <li>
                <router-link to="/ventas/punto-venta" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/ventas/punto-venta')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Punto de Venta</span>
                </router-link>
              </li>
              <li>
                <router-link to="/ventas/historial" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/ventas/historial')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Historial</span>
                </router-link>
              </li>
              <li>
                <router-link to="/ventas/cortes-caja" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/ventas/cortes-caja')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Cortes de Caja</span>
                </router-link>
              </li>
              <li>
                <router-link to="/ventas/reportes" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/ventas/reportes')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Reportes</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Producción Section -->
        <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
        <ul>
          <li>
            <button @click="toggleProduccion" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isProduccionActive() + ' pr-4'">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
                </svg>
                <span v-if="open">Producción</span>
              </div>
              <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="produccionOpen ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <ul v-if="produccionOpen && open" class="ml-4 mt-1 space-y-1">
              <li>
                <router-link to="/produccion/dashboard" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/produccion/dashboard')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Dashboard</span>
                </router-link>
              </li>
              <li>
                <router-link to="/produccion/tracker" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/produccion/tracker')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Tracker</span>
                </router-link>
              </li>
              <li>
                <router-link to="/produccion/ordenes" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/produccion/ordenes')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Órdenes de Producción</span>
                </router-link>
              </li>
              <li>
                <router-link to="/produccion/mi-monitor" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/produccion/mi-monitor')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Mi Monitor</span>
                </router-link>
              </li>
              <li>
                <router-link to="/produccion/monitor-general" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/produccion/monitor-general')">
                  <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                  <span class="truncate">Monitor General</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Herramientas Section -->
        <!-- <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
        <ul>
          <li>
            <router-link to="/herramientas/calculadora-precios" class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/herramientas/calculadora-precios')">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
              </svg>
              <span v-if="open">Calculadora de Precios</span>
            </router-link>
          </li>
        </ul> -->

        <div class="my-2 border-t border-gray-100 dark:border-gray-700"></div>
      <ul>
        <li>
          <button @click="toggleCatalogos" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isCatalogosActive() + ' pr-4'">
            <div class="flex items-center gap-3">
              <svg class="w-4 h-4 text-violet-500 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/></svg>
              <span v-if="open">Catálogos</span>
            </div>
            <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="catalogosOpen ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <ul v-if="catalogosOpen && open" class="ml-4 mt-1 space-y-1">
            <!-- <li v-if="userStore.canManageUsers">
              <router-link to="/users" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/users')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Usuarios</span>
          </router-link>
        </li> -->
        <!-- <li>
              <router-link to="/tipos-componente" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/tipos-componente')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Tipos de Componente</span>
          </router-link>
        </li>
        <li>
              <router-link to="/componentes" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/componentes')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Componentes</span>
          </router-link>
        </li>
        <li>
              <router-link to="/secciones" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/secciones')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Secciones</span>
          </router-link>
        </li>
        <li>
              <router-link to="/seccion-componente" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/seccion-componente')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Sección - Componente</span>
          </router-link>
            </li> -->
        <li>
              <router-link to="/contactos" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/contactos')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Contactos</span>
              </router-link>
            </li>
            <li>
              <router-link to="/usos-cfdi" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/usos-cfdi')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Usos de CFDI</span>
              </router-link>
            </li>
            <li>
              <router-link to="/tipos-pago" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/tipos-pago')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Tipos de Pago</span>
              </router-link>
            </li>
            <li>
              <router-link to="/formas-pago" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/formas-pago')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Formas de Pago</span>
              </router-link>
            </li>
            <li>
              <router-link to="/proveedores" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/proveedores')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Proveedores</span>
              </router-link>
            </li>
            <li>
              <router-link to="/fracciones" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/fracciones')">
                <div class="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500"></div>
                <span class="truncate">Fracciones</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <div class="my-4 border-t border-gray-100 dark:border-gray-700"></div>
      <ul>
        <li>
          <button @click="toggleCatalogosV2" class="w-full flex items-center justify-between gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isCatalogosV2Active() + ' pr-4'">
            <div class="flex items-center gap-3">
              <svg class="w-4 h-4 text-green-500 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"/>
              </svg>
              <span v-if="open">Catálogos V2</span>
            </div>
            <svg v-if="open" class="w-3 h-3 text-gray-500 dark:text-gray-300 transition-transform duration-200" :class="catalogosV2Open ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <ul v-if="catalogosV2Open && open" class="ml-4 mt-1 space-y-1">
            <!-- <li>
              <router-link to="/tipos-componente-new" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/tipos-componente-new')">
                <div class="w-2 h-2 rounded-full bg-green-400 dark:bg-green-500"></div>
                <span class="truncate">Tipos de Componente</span>
              </router-link>
            </li> -->
            <li>
              <router-link to="/catalogos-gestion-completa" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/catalogos-gestion-completa')">
                <div class="w-2 h-2 rounded-full bg-orange-400 dark:bg-orange-500"></div>
                <span class="truncate">🔧 Catálogos + Campos</span>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/catalogos-gestion" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/catalogos-gestion')">
                <div class="w-2 h-2 rounded-full bg-green-400 dark:bg-green-500"></div>
                <span class="truncate">Catálogos (Simple)</span>
              </router-link>
            </li>
            <li>
              <router-link to="/campos-catalogo-new" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/campos-catalogo-new')">
                <div class="w-2 h-2 rounded-full bg-green-400 dark:bg-green-500"></div>
                <span class="truncate">Campos de Catálogo</span>
              </router-link>
            </li> -->
            <li>
              <router-link to="/catalogos-new" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/catalogos-new')">
                <div class="w-2 h-2 rounded-full bg-green-400 dark:bg-green-500"></div>
                <span class="truncate">Registros de Catálogo</span>
              </router-link>
            </li>
            <li>
              <router-link to="/secciones-new" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/secciones-new')">
                <div class="w-2 h-2 rounded-full bg-green-400 dark:bg-green-500"></div>
                <span class="truncate">Secciones</span>
              </router-link>
            </li>
            <li>
              <router-link to="/seccion-catalogo-gestion" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/seccion-catalogo-gestion')">
                <div class="w-2 h-2 rounded-full bg-green-400 dark:bg-green-500"></div>
                <span class="truncate">Catálogos por Sección</span>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/seccion-tipo-componente-new" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/seccion-tipo-componente-new')">
                <div class="w-2 h-2 rounded-full bg-green-400 dark:bg-green-500"></div>
                <span class="truncate">Sección - Tipo Componente</span>
              </router-link>
            </li> -->
            <li>
              <router-link to="/prototipos-new" class="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition hover:bg-violet-50 dark:hover:bg-gray-700 hover:text-violet-700 hover:cursor-pointer" :class="isActive('/prototipos-new')">
                <div class="w-2 h-2 rounded-full bg-green-400 dark:bg-green-500"></div>
                <span class="truncate">Prototipos V2</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <!-- <div class="my-4 border-t border-gray-100 dark:border-gray-700"></div> -->
      
      
      
      <!-- <div class="px-4 text-xs text-gray-400 dark:text-gray-300 uppercase tracking-wider mb-2" v-if="open">UI Elements</div>
      <ul>
        <li>
          <a class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 text-gray-400 dark:text-gray-500 cursor-not-allowed">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-6a2 2 0 012-2h2a2 2 0 012 2v6m-6 0h6"/></svg>
            <span v-if="open">Cards</span>
          </a>
        </li>
        <li>
          <a class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg mb-0.5 text-gray-400 dark:text-gray-500 cursor-not-allowed">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg>
            <span v-if="open">Components</span>
          </a>
        </li>
      </ul> -->
      </div> <!-- End of regular menu sections -->
    </nav>
  </aside>
</template>
<script setup>
import { useRoute } from 'vue-router';
import { ref, computed } from 'vue';
import { useUserStore } from '@/stores/user';

const props = defineProps({
  open: Boolean,
  mobile: Boolean
});

const route = useRoute();
const userStore = useUserStore();
const catalogosOpen = ref(false);
const hasBeenToggled = ref(false);
const pagesOpen = ref(false);
const pagesHasBeenToggled = ref(false);
const productosOpen = ref(false);
const pos2HasBeenToggled = ref(false);
const pos2Open = ref(false);
const productosHasBeenToggled = ref(false);
const cotizacionesOpen = ref(false);
const cotizacionesHasBeenToggled = ref(false);
const pedidosOpen = ref(false);
const pedidosHasBeenToggled = ref(false);
const catalogosV2Open = ref(false);
const catalogosV2HasBeenToggled = ref(false);
const finanzasOpen = ref(false);
const finanzasHasBeenToggled = ref(false);
const inventarioOpen = ref(false);
const inventarioHasBeenToggled = ref(false);
const ventasOpen = ref(false);
const ventasHasBeenToggled = ref(false);
const produccionOpen = ref(false);
const produccionHasBeenToggled = ref(false);
// Check if current route is an admin route
const isInAdminRoute = computed(() => {
  const adminRoutes = ['/admin/users', '/admin/negocios', '/admin/usuario-negocio', '/admin/usuario-negocio-v2', '/admin/usuario-negocio-v3'];
  return adminRoutes.includes(route.path);
});


function isActive(path) {
  const isDirectMatch = route.path === path;
  const isPrototiposMatch = path === '/prototipos' && (route.path === '/prototipos' || route.path === '/prototipos/nuevo' || (route.path.startsWith('/prototipos/') && route.path.includes('/editar')));
  
  return (isDirectMatch || isPrototiposMatch)
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-md mx-1'
    : 'text-gray-700 dark:text-white';
}

function isCatalogosActive() {
  // Excluir rutas de admin del catálogo normal
  const catalogosRoutes = ['/componentes', '/tipos-componente', '/secciones', '/seccion-componente', '/contactos', '/fracciones', '/catalogos-new', '/usos-cfdi', '/tipos-pago', '/formas-pago', '/proveedores'];
  const isActive = catalogosRoutes.includes(route.path);

  // Solo auto-expandir si no se ha hecho clic manualmente
  if (isActive && !catalogosOpen.value && !hasBeenToggled.value) {
    catalogosOpen.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function toggleCatalogos() {
  catalogosOpen.value = !catalogosOpen.value;
  hasBeenToggled.value = true;
}

function isPagesActive() {
  const pagesRoutes = ['/dashboard', '/analytics', '/products', '/profile'];
  const isActive = pagesRoutes.includes(route.path);
  
  // Solo auto-expandir si no se ha hecho clic manualmente
  if (isActive && !pagesOpen.value && !pagesHasBeenToggled.value) {
    pagesOpen.value = true;
  }
  
  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function togglePages() {
  pagesOpen.value = !pagesOpen.value;
  pagesHasBeenToggled.value = true;
}

function isProductosActive() {
  const productosRoutes = ['/prototipos', '/prototipos/nuevo', '/cotizaciones'];
  const isActive = productosRoutes.includes(route.path) || 
                   (route.path.startsWith('/prototipos/') && route.path.includes('/editar')) ||
                   (route.path.startsWith('/cotizaciones/'));
  
  // Solo auto-expandir si no se ha hecho clic manualmente
  if (isActive && !productosOpen.value && !productosHasBeenToggled.value) {
    productosOpen.value = true;
  }
  
  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}
function isPOS2Active() {
  const isActive = route.path.startsWith('/pos2/');

  if (isActive && !pos2Open.value && !pos2HasBeenToggled.value) {
    pos2Open.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function togglePOS2() {
  pos2Open.value = !pos2Open.value;
  pos2HasBeenToggled.value = true;
}
function toggleProductos() {
  productosOpen.value = !productosOpen.value;
  productosHasBeenToggled.value = true;
}

function isCotizacionesActive() {
  const cotizacionesRoutes = ['/cotizaciones', '/cotizaciones/dashboard'];
  const isActive = cotizacionesRoutes.includes(route.path) || route.path.startsWith('/cotizaciones/');

  // Solo auto-expandir si no se ha hecho clic manualmente
  if (isActive && !cotizacionesOpen.value && !cotizacionesHasBeenToggled.value) {
    cotizacionesOpen.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function toggleCotizaciones() {
  cotizacionesOpen.value = !cotizacionesOpen.value;
  cotizacionesHasBeenToggled.value = true;
}

function isPedidosActive() {
  const pedidosRoutes = ['/pedidos'];
  const isActive = pedidosRoutes.includes(route.path) || route.path.match(/\/pedidos\/\d+/);

  // Solo auto-expandir si no se ha hecho clic manualmente
  if (isActive && !pedidosOpen.value && !pedidosHasBeenToggled.value) {
    pedidosOpen.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function togglePedidos() {
  pedidosOpen.value = !pedidosOpen.value;
  pedidosHasBeenToggled.value = true;
}

function isFinanzasActive() {
  const finanzasRoutes = ['/finanzas/tablero', '/finanzas/cuentas-bancarias'];
  const isActive = finanzasRoutes.includes(route.path) || route.path.startsWith('/finanzas/');

  // Solo auto-expandir si no se ha hecho clic manualmente
  if (isActive && !finanzasOpen.value && !finanzasHasBeenToggled.value) {
    finanzasOpen.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function toggleFinanzas() {
  finanzasOpen.value = !finanzasOpen.value;
  finanzasHasBeenToggled.value = true;
}

function isCatalogosV2Active() {
  const catalogosV2Routes = ['/tipos-componente-new', '/catalogos-gestion', '/catalogos-gestion-completa', '/campos-catalogo-new', '/catalogos-new', '/secciones-new', '/seccion-catalogo-gestion', '/seccion-tipo-componente-new', '/prototipos-new'];
  const isActive = catalogosV2Routes.includes(route.path);

  // Solo auto-expandir si no se ha hecho clic manualmente
  if (isActive && !catalogosV2Open.value && !catalogosV2HasBeenToggled.value) {
    catalogosV2Open.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function toggleCatalogosV2() {
  catalogosV2Open.value = !catalogosV2Open.value;
  catalogosV2HasBeenToggled.value = true;
}

function isInventarioActive() {
  const isActive = route.path.startsWith('/inventario/');

  if (isActive && !inventarioOpen.value && !inventarioHasBeenToggled.value) {
    inventarioOpen.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function toggleInventario() {
  inventarioOpen.value = !inventarioOpen.value;
  inventarioHasBeenToggled.value = true;
}

function isVentasActive() {
  const isActive = route.path.startsWith('/ventas/');

  if (isActive && !ventasOpen.value && !ventasHasBeenToggled.value) {
    ventasOpen.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function toggleVentas() {
  ventasOpen.value = !ventasOpen.value;
  ventasHasBeenToggled.value = true;
}

function isProduccionActive() {
  const isActive = route.path.startsWith('/produccion/');

  if (isActive && !produccionOpen.value && !produccionHasBeenToggled.value) {
    produccionOpen.value = true;
  }

  return isActive
    ? 'bg-violet-100 dark:bg-gray-700 text-violet-700 dark:text-white font-semibold rounded-lg mr-4'
    : 'text-gray-700 dark:text-white';
}

function toggleProduccion() {
  produccionOpen.value = !produccionOpen.value;
  produccionHasBeenToggled.value = true;
}
</script>
